import { useState, useEffect } from 'react'
import { ButtonFilledAutoWidth, ButtonOutlinedAutoWidth } from '../../components/button'
import { DatePicker, Modal, Select } from 'antd';
import { useNavigate } from 'react-router-dom';
import { FiChevronRight, FiChevronLeft } from 'react-icons/fi';
import { IconButton } from '@material-ui/core';
import { AiOutlineEdit,AiOutlineDelete,AiOutlineFileExcel } from 'react-icons/ai';
import toast from 'react-hot-toast';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { DeleteInvoiceService, DownloadInvoiceService, GetInvoiceService } from '../../services/admin/InvoiceServices';
import SettingsMenu from '../staticscreens/SettingsMenu';
import { CiViewTable } from "react-icons/ci";
import OfflineCustomerMenu from './InvoiceMenu';

function InvoiceList() {

  const navigator = useNavigate()
  const roles = useSelector(state=>state.Auth.roles)



  const [modal, setmodal] = useState(false)
  const [page, setpage] = useState(1)
  const [data, setdata] = useState({})
  const [selecteddata, setselecteddata] = useState({})
  

  const [search, setsearch] = useState({ text: '',text1: '', from_date: '', to_date: '', from_date1: '', to_date1: '', activate: false })

  useEffect(() => {
    getdata()
  }, [page])

  async function getdata() {
    const response = await GetInvoiceService(page,search?.text,search?.from_date1,search?.to_date1);
    setdata(response?.data)
  }


  async function applyFilter() {
    setsearch({ ...search, activate: true })
    setpage(1)
    const response = await GetInvoiceService(1,search?.text,search?.from_date1,search?.to_date1)
    setdata(response?.data)
  }

  async function resetfilter() {
    setsearch({ text: '', from_date: '', to_date: '', from_date1: '', to_date1: '', activate: false,text1:'',teacher:'' })
    setpage(1)
    const response = await GetInvoiceService(1,'','','')
    setdata(response?.data)
  }


  async function deleteData() {
    const response = await  DeleteInvoiceService(selecteddata?._id)
    if (response?.status === 200) {
      toast.success("Deleted Successfully")
    } else {
      toast.success("Deleted Successfully")
    }
    setmodal(false)
    getdata()
  }

   async function downloaddata() {
      const response = await DownloadInvoiceService(1, search?.text1, search?.from_date1, search?.to_date1, '','', search?.text ? search?.text?.data?.standard : '')
      let path = response.data.path.replace('public/', '')
      let url = `${process.env.REACT_APP_BACKEND_IMAGE_URL}${path}`
      window.open(url,'_blank')
      // handleDownload(`${process.env.REACT_APP_BACKEND_IMAGE_URL}${path}`, path.split('/')[path.split('/')?.length - 1])
    }

 
  return (
    <div className='w-[98%] md:h-screen md:overflow-hidden'>

      <Modal
        keepMounted
        open={modal}
        onClose={() => setmodal(false)}
        width={300}
        footer={false}
        closable={false}

      >
        <div >
          <h6 className="font-bold text-[15px] text-center mb-2 w-full">Are you sure?</h6>
          <h6 className='bg-slate-100 text-center text-[12px] p-1.5 font-[400]'>After deleting you cannot retrieve it back before deleting check once whether you have used it in some data</h6>
          <div className='flex justify-end mt-3 '>
            <ButtonOutlinedAutoWidth btnName={'Cancel'} onClick={() => setmodal(false)} />
            <div className='ml-2'>
              <ButtonFilledAutoWidth btnName={'Confirm'} onClick={() => deleteData()} />
            </div>
          </div>
        </div>
      </Modal>

      <div className='md:flex'>
        <div>
          <OfflineCustomerMenu />
        </div>
        <div className='md:w-[90%] pl-5 mt-4'>

          <div className='md:flex items-center -mt-1 border-b justify-between pb-1'>
            <div className='flex items-center justify-between'>
            <h6 className='font-[800] text-[13px]'>Total Invoices ({data?.pagination?.total})</h6>
            <div className='flex md:hidden items-center text-[12px]'>
              <AiOutlineFileExcel onClick={() => downloaddata()} size={24} className='mx-2 bg-gray-200 p-1.5' />

              <h6 className='mr-2 font-[600]'>{page == 1 ? data?.datas?.length > 0 ? 1 : 0 : (page - 1) * data?.pagination?.limit} - {data?.pagination?.limit} of {data?.pagination?.total}  </h6>

              <div>
                <IconButton onClick={() => { page > 1 ? setpage(page - 1) : console.log('') }}><FiChevronLeft className={`${page === 1 ? 'opacity-50' : 'opacity-100'}`} size={16} /></IconButton>
                <IconButton onClick={() => { page < data?.pagination?.totalPages ? setpage(page + 1) : console.log('') }}><FiChevronRight className={`${(data?.pagination?.totalPages === page || data?.datas?.length === 0) ? 'opacity-50 ' : 'opacity-100'}`} size={16} /></IconButton>
              </div>
            </div>
            </div>

            <div className='flex flex-wrap items-center text-[12px]'>

              <div className='hidden md:flex items-center'>
              <AiOutlineFileExcel onClick={() => downloaddata()} size={24} className='mx-2 bg-gray-200 p-1.5' />

              <h6 className='mr-2 font-[600]'>{page == 1 ? data?.datas?.length > 0 ? 1 : 0 : (page - 1) * data?.pagination?.limit} - {data?.pagination?.limit} of {data?.pagination?.total}  </h6>

              <div>
                <IconButton onClick={() => { page > 1 ? setpage(page - 1) : console.log('') }}><FiChevronLeft className={`${page === 1 ? 'opacity-50' : 'opacity-100'}`} size={16} /></IconButton>
                <IconButton onClick={() => { page < data?.pagination?.totalPages ? setpage(page + 1) : console.log('') }}><FiChevronRight className={`${(data?.pagination?.totalPages === page || data?.datas?.length === 0) ? 'opacity-50 ' : 'opacity-100'}`} size={16} /></IconButton>
              </div>
              </div>

              <div className='mr-2 flex items-center mt-1 md:mt-0'>

                <input id="search_text" placeholder='Search text' type='text' value={search.text} onChange={(e) => setsearch({ ...search, text: e.target.value })} className='border py-[3px] mr-2 focus:ring-0 focus:outline-0 text-[14px]  w-[100px] px-1 rounded-md border-slate-300' />

                <DatePicker size='small' style={{ fontSize: '11px' }} ampm={false} placeholder='From Date' className='text-[11px] py-[2.6px]  w-28 border-slate-300 mr-2' value={search?.from_date} onChange={(v, v1) => { console.log('v na', new Date(v).toLocaleDateString()); setsearch({ ...search, from_date: v, from_date1: v1 }) }} />

                <DatePicker size='small' style={{ fontSize: '11px' }} ampm={false} placeholder='To Date' className='text-[11px] py-[2.6px]  w-28 border-slate-300 mr-2' value={search?.to_date} onChange={(v, v1) => { console.log('v na', new Date(v).toLocaleDateString()); setsearch({ ...search, to_date: v, to_date1: v1 }) }} />

              </div>
              <div className='mr-2 mt-1 md:mt-0'>
                <ButtonOutlinedAutoWidth btnName="Apply Filter" onClick={() => applyFilter()} />
              </div>
              <div className='mr-2 mt-1 md:mt-0'>
                <ButtonOutlinedAutoWidth btnName="Reset Filter" onClick={() => resetfilter()} />
              </div>
           
            </div>
          </div>


          <div className='md:h-[90vh] mb-[50px] md:overflow-hidden'>

            {data?.datas?.length === 0 &&
              <div className='grid place-items-center mt-20  items-center justify-center'>
                <img src={'https://fidecrmfiles.s3.amazonaws.com/NoDataFound1.png'} className='w-40 h-40 object-contain' />
                <h6 className='font-bold text-[14px] -mt-10'>No data found</h6>
                <h6 className='font-[500] w-[70%] text-center text-slate-700 text-[12.5px] -mt-2'>Oops we couldn't find any data based on your current stage please add the data to see list here.</h6>
              </div>}

            <div className='w-[100%] overflow-hidden'>
              {data?.datas?.length > 0 &&
                <>
                {/* Desktop / tablet table */}
                <div className='hidden md:block md:max-h-[85vh] mt-4 md:overflow-auto border-t border-l border-r'>
                  <div className='sticky top-0 z-50 flex w-full  bg-white py-[-5px] border-b border-slate-200 relative'>
                    <h6 className='top-0 bg-white z-50 text-[12px] min-w-[50px] w-[50px]  px-2 py-1 font-[600] text-slate-800 border-r flex items-center justify-center'>Sl No</h6>
                    <h6 className='sticky top-0 z-50  text-[12px]  min-w-[160px] w-[160px]  px-2 py-1 font-[600] text-slate-800 border-r'>Student Name </h6>
                    <h6 className='sticky top-0 z-50  text-[12px]  min-w-[160px] w-[160px]  px-2 py-1 font-[600] text-slate-800 border-r'>Total Amount</h6>
                    <h6 className='sticky top-0 z-50  text-[12px] min-w-[180px] w-[180px]  px-2 py-1 font-[600] text-slate-800 border-r'>Payment Date</h6>
                    <h6 className='sticky top-0 z-50  text-[12px] min-w-[250px] w-[250px]  px-2 py-1 font-[600] text-slate-800 border-r'>Fee Details</h6>
                    <h6 className='sticky top-0 z-50  text-[12px] min-w-[140px] w-[140px]  px-2 py-1 font-[600] text-slate-800 border-r'>Created At</h6>
                    <h6 className='sticky top-0 z-50  text-[12px] min-w-[120px] w-[120px]  px-2 py-1 font-[600] text-slate-800'>Action</h6>
                  </div>
                  {data?.datas?.map((d, i) => (
                    <div key={d?._id || i} className='flex w-full text-[11px]  bg-white py-[-5px] border-b border-slate-200 relative'>
                      <h6 className='bg-white text-[12px] min-w-[50px] w-[50px]  px-2 py-1 font-[500] border-r flex items-start justify-center'>{(page > 1 ? i + 1 + (data?.pagination?.limit * (page - 1)) : i + 1)}</h6>

                      <h6 className=' text-[12px] break-word min-w-[160px] w-[160px] px-2 py-1 font-[500] border-r'>
                        <span className='font-bold break-all'>{d?.invoice_number}</span>
                        <span className='font-bold'>{d?.customer?.name}</span><br></br>
                        <span className='font-bold'>{d?.customer?.mobile}</span><br></br>
                        {d?.customer?.fees_end_date && <span className='text-[9px]'>Fees End Date : {moment(d?.customer?.fees_end_date)?.format('LL')}</span>}
                      </h6>
                      <h6 className=' text-[12px] break-all min-w-[160px] w-[160px]  px-2 py-1 font-[500] border-r'>
                       <h6 className='text-[11px]'>{d?.total_amount}</h6>
                      </h6>
                      <h6 className=' text-[11px] break-all min-w-[180px] w-[180px]  px-2 py-1  border-r'>
                        {moment(d?.payment_date)?.format('ll')}
                      </h6>
                      <h6 className='flex break-word  min-w-[250px] w-[250px]  px-2 py-1 font-[500] border-r'>
                        {JSON.stringify(d?.fee_details) !== '[]' && d?.fee_details?.length > 0 && d?.fee_details?.map((f, i) => (
                          <div key={i} className='mr-2 mb-1 p-1 w-max text-[10px] rounded-md'>
                            <h6 className='font-bold'>{f?.line_item}</h6>
                            <h6 className='text-[11px]'>{f?.price}</h6>
                          </div>
                        ))}
                      </h6>


                      <h6 className='  break-word min-w-[140px] w-[140px]  px-2 py-1 font-[500] border-r'>{moment(d?.createdAt)?.format('lll')}</h6>
                      <h6 className='text-[12px] flex items-start min-w-[120px] w-[120px]  px-2 py-1 font-[600] text-slate-800'>
                        <AiOutlineEdit onClick={() => navigator('edit', { state: d })} className='mr-2' />
                        <AiOutlineDelete onClick={() => {setselecteddata(d);setmodal(true)}} className='mr-2' />
                      </h6>
                    </div>))}
                </div>

                {/* Mobile card list */}
                <div className='md:hidden mt-3 space-y-2'>
                  {data?.datas?.map((d, i) => (
                    <div key={d?._id || i} className='border rounded-md p-3 bg-white'>
                      <div className='flex items-start justify-between'>
                        <div>
                          <h6 className='text-[13px] font-[700]'>{d?.customer?.name}</h6>
                          <h6 className='text-[11px] text-slate-600'>{d?.customer?.mobile}</h6>
                        </div>
                        <div className='flex items-center -mr-1.5'>
                          <span className='p-2 cursor-pointer'><AiOutlineEdit size={17} onClick={() => navigator('edit', { state: d })} /></span>
                          <span className='p-2 cursor-pointer'><AiOutlineDelete size={17} onClick={() => {setselecteddata(d);setmodal(true)}} /></span>
                        </div>
                      </div>

                      {d?.customer?.fees_end_date && <h6 className='text-[10px] text-slate-500 mt-1'>Fees End Date : {moment(d?.customer?.fees_end_date)?.format('LL')}</h6>}

                      <div className='flex items-center justify-between mt-2 text-[11px]'>
                        <h6><span className='font-[600]'>Total:</span> {d?.total_amount}</h6>
                        <h6><span className='font-[600]'>Paid:</span> {moment(d?.payment_date)?.format('ll')}</h6>
                      </div>

                      {JSON.stringify(d?.fee_details) !== '[]' && d?.fee_details?.length > 0 &&
                      <div className='flex flex-wrap mt-2'>
                        {d?.fee_details?.map((f, fi) => (
                          <div key={fi} className='mr-2 mb-1 p-1.5 bg-slate-50 rounded text-[10px]'>
                            <h6 className='font-bold'>{f?.line_item}</h6>
                            <h6 className='text-[11px]'>{f?.price}</h6>
                          </div>
                        ))}
                      </div>}

                      <h6 className='text-[10px] text-slate-400 mt-2'>Created {moment(d?.createdAt)?.format('lll')}</h6>
                    </div>
                  ))}
                </div>
                </>}
            </div>

          </div>

        </div>
      </div>
    </div>
  )
}

export default InvoiceList